import { CU_TEST, CU_LOGIN, CU_LOGOUT } from '../actions/ClaveUnicaActions';
import { URL_LOOUT_CLAVE_UNICA, SITE_URL } from '../../config/config';

const stringUser = sessionStorage.getItem('user') || null;
const initialState = {
  user: stringUser,
};

const ClaveUnica = (state = initialState, action) => {
  switch (action.type) {
    case CU_TEST:
      return state;
    case CU_LOGIN:
      sessionStorage.setItem('user', JSON.stringify(action.payload));
      return {
        ...state,
        user: action.payload,
      };
    case CU_LOGOUT:
/*       sessionStorage.removeItem('user');
      sessionStorage.removeItem('dynamicMenu');
      sessionStorage.removeItem('idNav')
      sessionStorage.removeItem('tipo_atencion')
      sessionStorage.removeItem('tipo_administracion')
      sessionStorage.removeItem('parentIdNav')
      sessionStorage.removeItem('idFicha')
      sessionStorage.removeItem('region') */
      sessionStorage.clear()

      window.location.href = URL_LOOUT_CLAVE_UNICA + '?redirect=' + SITE_URL;
      return {
        ...state,
        user: null,
      };
    default:
      return state;
  }
};

export default ClaveUnica;
